import React from "react";
import { ChevronRight } from "lucide-react";

// Worst state wins the colour: failed, then in progress, then all launched, then ready.
const tone = (s) =>
  s.failed ? "bg-rose-50 text-rose-700 border-rose-200"
  : s.in_progress ? "bg-amber-50 text-amber-700 border-amber-200"
  : s.launched === s.total ? "bg-emerald-50 text-emerald-700 border-emerald-200"
  : s.ready ? "bg-sky-50 text-sky-700 border-sky-200"
  : "bg-gray-50 text-gray-600 border-gray-200";

/** "2 of 3 launched" chip for the request list; opens the per-hook modal. Dash until any hook nears launch. */
const LaunchSummaryChip = ({ summary, onClick }) => {
  const s = summary || {};
  if (!s.total || !(s.launched || s.failed || s.in_progress || s.ready)) {
    return <span className="text-gray-400">—</span>;
  }
  const text = s.launched === s.total ? "All launched" : `${s.launched} of ${s.total} launched`;
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium transition-colors hover:brightness-95 ${tone(s)}`}
    >
      {text}
      {s.failed > 0 && <span className="font-semibold">· {s.failed} failed</span>}
      <ChevronRight className="h-3 w-3 opacity-60" />
    </button>
  );
};

export default LaunchSummaryChip;
